import {NgModule}      from '@angular/core';
import {CommonModule}  from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Routes, RouterModule}  from '@angular/router';


import {Portfolio} from './portfolio.page';


export const routes: Routes = [
    {path: 'portfolio', component: Portfolio},

];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        Portfolio
    ]

})

export class PortfolioModule {
}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/portfolio/portfolio.module.ts